module.exports = __webpack_public_path__ + "img/btn_main1_03.801c0870.png";